import { defineQueryOptions } from '@pinia/colada';
import { api, ApiError } from './client.ts';
import type { components } from './schema.gen.ts';
import { messageOf } from './serverFailure.ts';

export type Player = components['schemas']['Player'];
export type PlayerSession = components['schemas']['PlayerSession'];
export type Standing = components['schemas']['Standing'];

export const playerKeys = {
  session: ['player', 'session'] as const,
};

export const playerSessionQuery = defineQueryOptions({
  key: playerKeys.session,
  query: async (): Promise<null | PlayerSession> => {
    const { data, error, response } = await api.GET('/session');
    if (response.ok && !data) return null;
    if (!data) throw new ApiError(response.status, error && messageOf('playerSession', error), error?.slug);
    return data;
  },
});
